import { OciIcon } from './OciIcon';

/**
 * author: Contributors
 * id 53021908-1FB5-4293-896E-94C5330E6101
 * name oci
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/oci.svg
 * tags
 * - Developer / Languages 
 * - Brand / Logo 
 */
export const OpenContainerInitiativeIcon = OciIcon;
export default OpenContainerInitiativeIcon